export enum StopPointType {
  unknown = 'unknown',
  trainStop = 'trainstop',
  other = 'other',
}
